<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		alt="PS2Conv"
		baseProfile="tiny"
		class="logo"
		overflow="visible"
		version="1.2"
		viewBox="0 0 1200.5 358.1"
	>
		<g fill="#00A8FF">
			<path
				d="M0 144.3h256v27H0zM311.3 171.3h36v-54.6h39.8c36.5 0 63.4-23.5 63.4-56.9 0-33.3-27-56.9-63.4-56.9h-75.8v80.7H200.7v33h110.6v54.7zm36-135.3h35.8c18 0 30.2 9.3 30.2 23.8S401 83.6 383 83.6h-35.7V36zM528.3 3l-68.7 168.3h40.5l10.7-26.4h75l10.9 26.4h40.6L568.7 3h-40.5zm-5 111.2l25-61.5 25 61.5h-50zM796.4 59.8c0-33.3-27-56.9-63.5-56.9h-75.7v168.4h36v-54.6H720l38.5 54.6h41.2l-41.4-58.8c23-8 38.2-27.7 38.2-52.7zM729 83.6h-35.8V36H729c17.9 0 30.1 9.3 30.1 23.8S747 83.6 729 83.6zM880.5 32.9c13.7 0 25.5 8.3 25.5 22.3 0 11.7-6.4 22.8-26.5 38.7l-62 48v29.4h127.2v-32.6h-71.3L904 115c29.4-21.4 39.2-38.8 39.2-61.3 0-31.6-26-53.7-61.7-53.7a79.8 79.8 0 00-65.2 32.9l23 22.3c12.3-14 24.8-22.4 41.2-22.4zM394.2 216.7c15.4 0 29.4 7.6 39.2 18.9l26.2-23.6a90.1 90.1 0 00-65.4-28.2c-48.3 0-89.5 39.7-89.5 87s41.2 87.3 89.5 87.3c25.5 0 49-11 65.4-28.2l-26.2-23.5a52.4 52.4 0 01-39.2 18.9c-28.2 0-52.2-25-52.2-54.5 0-29.1 24-54.1 52.2-54.1zM728.3 225.5a45.2 45.2 0 00-38.3 18.9v-16h-35.8v126.8H690v-75.8l.3.8c0-13.8 11.5-24.6 26.5-24.6 14.2 0 24 10.8 24 26.5v73h34.5v-80.6c0-28.7-19.6-49-47-49zM907.2 228.4L873.9 314l-34.1-85.6h-37.5l54.9 126.8h33.1l42.6-99.8h267.6v-27zM587.3 287.7h-.2l.2 4a36 36 0 01-34.8 36.3c-19.1 0-35-16.7-35-36.3a35.9 35.9 0 0137.8-36 32 32 0 0115.8-27.6c-6-1.7-12.2-2.6-18.6-2.6-37.7 0-69.4 30.2-69.4 66.2s31.7 66.4 69.4 66.4c37.5 0 68.9-30.4 68.9-66.4 0-8.2-1.7-16.1-4.6-23.5a32 32 0 01-29.5 19.5z"
			/>
		</g>
		<path
			fill="#66CBFF"
			d="M587.3 295.7a40 40 0 11.1-80.1 40 40 0 010 80zm0-64a24 24 0 100 48 24 24 0 000-48z"
		/>
	</svg>
</template>

<style lang="scss" scoped>
.logo {
	width: 75%;
	max-width: 480px;
}
</style>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
	name: "Logo"
})
</script>
